"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.round = void 0;
const round = (n, dp = 2) => Math
    .round((n + Number.EPSILON) * (Math.pow(10, dp))) / (Math.pow(10, dp));
exports.round = round;
//# sourceMappingURL=math.js.map